module.exports = __webpack_public_path__ + "img/icon_dropdown.4b6354e7.svg";